<template>
  <div class="">
    <div class="columns is-multiline is-flex is-justify-content-space-between is-align-items-center mb-4">
      <div class="column is-12">
        <p class="has-text-grey has-text-weight-semibold is-uppercase is-size-7">Invitados</p>
        <h2 class="title is-4 mb-0">Listado de invitados</h2>
        <p class="has-text-grey is-size-7">Filtra, agrega y actualiza el listado de asistencia.</p>
      </div>
      <div class="column is-12">
        <div class="buttons guests-actions">
          <b-button size="is-small" icon-left="qrcode-scan" type="is-info" @click="openScanner">Escáner</b-button>
          <b-button size="is-small" icon-left="file-import" type="is-success" @click="showImportModal = true">Importar</b-button>
          <b-button size="is-small" icon-left="file-export" type="is-success" @click="exportGuests">Exportar</b-button>
          <b-button size="is-small" icon-left="account-plus" type="is-link"  @click="openGuestModal('invitado')">Invitados</b-button>
          <b-button size="is-small" icon-left="account-multiple" type="is-gray" @click="openGuestModal('socio')">Socios</b-button>
          <b-button size="is-small" icon-left="account-edit" type="is-warning" @click="openGuestModal('extra')">Agregar manual</b-button>
          <b-button size="is-small" icon-left="account-check" type="is-success" :disabled="!hasSelection" @click="updateAttendance('Asistió')">
            Asistencia
          </b-button>
          <b-button size="is-small" icon-left="email-send" type="is-info" :disabled="!hasSelection" @click="sendInvites"> Enviar correo </b-button>
          <b-button size="is-small" icon-left="delete" type="is-danger" :disabled="!hasSelection" @click="removeSelected"> Eliminar </b-button>
        </div>
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Buscar">
          <b-input v-model="searchQuery" placeholder="Nombre, correo o código" icon="magnify" @input="resetPage"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field label="Tipo">
          <b-select v-model="typeFilter" placeholder="Todos" expanded @input="resetPage">
            <option :value="''">Todos</option>
            <option value="socio">Socio</option>
            <option value="invitado">Invitado</option>
            <option value="extra">Manual</option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field label="Correo">
          <b-select v-model="mailFilter" placeholder="Todos" expanded @input="resetPage">
            <option :value="''">Todos</option>
            <option value="Enviado">Enviado</option>
            <option value="Pendiente">Pendiente</option>
          </b-select>
        </b-field>
      </div>
    </div>

    <b-table
      :data="paginatedGuests"
      :loading="loading"
      checkable
      hoverable
      striped
      :checked-rows.sync="checkedRows"
      :paginated="true"
      :per-page="perPage"
      :total="filteredGuests.length"
      :current-page.sync="currentPage"
    >
      <b-table-column v-slot="props" field="nombre" label="Nombre">
        <p class="has-text-weight-semibold">{{ props.row.nombre }}</p>
        <small class="has-text-grey">{{ props.row.tipo }}</small>
      </b-table-column>

      <b-table-column field="correo" label="Correo" v-slot="props">
        <span>{{ props.row.correo }}</span>
      </b-table-column>

      <b-table-column field="numeroSocio" label="Núm. Socio" v-slot="props">
        <span>{{ props.row.numeroSocio || 'N/A' }}</span>
      </b-table-column>

      <b-table-column field="nombreSocio" label="Nombre socio" v-slot="props">
        <span>{{ props.row.nombreSocio || 'N/A' }}</span>
      </b-table-column>

      <b-table-column field="vigencia" label="Vigencia" v-slot="props">
        <span>{{ props.row.vigencia || 'N/A' }}</span>
      </b-table-column>

      <b-table-column field="representante" label="Representante" v-slot="props">
        <div>{{ props.row.representante || 'N/A' }}</div>
        <small class="has-text-grey">{{ props.row.correoRepresentante || '' }}</small>
      </b-table-column>

      <b-table-column field="estatusCorreo" label="Estatus de correo" v-slot="props">
        <b-tag :type="props.row.estatusCorreo === 'Enviado' ? 'is-success is-light' : 'is-warning is-light'">
          {{ props.row.estatusCorreo }}
        </b-tag>
      </b-table-column>

      <b-table-column field="estatusAsistencia" label="Asistencia" v-slot="props">
        <b-tag :type="attendanceColor(props.row.estatusAsistencia)">
          {{ props.row.estatusAsistencia }}
        </b-tag>
      </b-table-column>

      <b-table-column field="codigo" label="Código" v-slot="props">
        <code>{{ props.row.codigo }}</code>
      </b-table-column>

      <b-table-column field="acciones" label="Acciones" width="120" v-slot="props">
        <div class="buttons">
          <b-button type="is-info" size="is-small" icon-left="pencil" @click="openGuestModal(props.row.tipo, props.row)"></b-button>
          <b-button type="is-danger" size="is-small" icon-left="delete" @click="removeGuest(props.row)"></b-button>
        </div>
      </b-table-column>
    </b-table>

    <div class="modal" :class="{ 'is-active': showImportModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">Importar invitados</h2>
          <button class="delete" aria-label="close" @click="closeImport"></button>
        </header>
        <section class="modal-card-body">
          <b-field label="Archivo de Excel">
            <b-upload v-model="importFile" drag-drop expanded>
              <section class="section">
                <div class="content has-text-centered">
                  <p><b-icon icon="upload"></b-icon></p>
                  <p>Arrastra o selecciona un archivo .xlsx o .csv</p>
                </div>
              </section>
            </b-upload>
          </b-field>
          <p class="is-size-7 has-text-grey">
            Este paso es solo de interfaz. En la integración real se procesará el archivo y se mostrará un resumen antes de guardar.
          </p>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
          <b-button @click="closeImport" type="is-text">Cancelar</b-button>
          <b-button @click="handleImport" type="is-primary" :disabled="!importFile">Simular importación</b-button>
        </footer>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': showGuestModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">{{ guestModalTitle }}</h2>
          <button class="delete" aria-label="close" @click="closeGuestModal"></button>
        </header>
        <section class="modal-card-body">
          <GuestForm
            :key="guestFormKey"
            :guest="editingGuest"
            :preset-type="presetType"
            :socios-options="sociosOptions"
            :invitados-options="invitadosOptions"
            @save="saveGuest"
            @cancel="closeGuestModal"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Swal from 'sweetalert2';
import GuestForm from './guest-form.vue';
import axiosInstance from '@/api/axiosInstance';

export default {
  components: {
    GuestForm,
  },
  props: {
    meetingId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      searchQuery: '',
      typeFilter: '',
      mailFilter: '',
      perPage: 10,
      currentPage: 1,
      checkedRows: [],
      showImportModal: false,
      importFile: null,
      showGuestModal: false,
      guestModalTitle: 'Agregar invitado',
      editingGuest: null,
      presetType: '',
      guestFormKey: 0,
      sociosOptions: [],
      invitadosOptions: [],
    };
  },
  computed: {
    ...mapState({
      guests: (state) => state.meetings.currentGuests,
    }),
    filteredGuests() {
      const search = this.searchQuery.toLowerCase();
      return this.guests.filter((guest) => {
        const name = (guest.nombre || '').toLowerCase();
        const email = (guest.correo || '').toLowerCase();
        const code = (guest.codigo || '').toLowerCase();
        const type = guest.tipo || '';
        const mailStatus = guest.estatusCorreo || '';

        const matchesSearch = !search || name.includes(search) || email.includes(search) || code.includes(search);

        const matchesType = this.typeFilter ? type === this.typeFilter : true;
        const matchesMail = this.mailFilter ? mailStatus === this.mailFilter : true;

        return matchesSearch && matchesType && matchesMail;
      });
    },
    paginatedGuests() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredGuests.slice(start, end);
    },
    hasSelection() {
      return this.checkedRows.length > 0;
    },
  },
  watch: {
    meetingId: {
      immediate: true,
      async handler() {
        await this.loadGuests();
      },
    },
  },
  methods: {
    ...mapActions({
      fetchGuests: 'meetings/fetchGuests',
      saveGuestAction: 'meetings/saveGuest',
      removeGuestsAction: 'meetings/removeGuests',
      updateGuestsStatus: 'meetings/updateGuestsStatus',
    }),
    async loadOptions() {
      try {
        const sociosResp = await axiosInstance.get('/associates/list?size=200&page=1');
        const sociosList = sociosResp?.data?.data?.associates?.list || [];
        this.sociosOptions = sociosList.map((s) => ({
          id: s.id,
          label: `${s.nombre} ${s.apellido} - ${s.empresa || ''}`.trim(),
          nombre: `${s.nombre} ${s.apellido}`.trim(),
          email: s.email || '',
          numeroSocio: s.socio || s.id,
          empresa: s.empresa || '',
        }));
      } catch (e) {
        console.warn('No se pudieron cargar socios', e);
      }

      try {
        const invitadosResp = await axiosInstance.get('/externals/list?size=200&page=1');
        const invitadosList = invitadosResp?.data?.data?.externals?.list || [];
        this.invitadosOptions = invitadosList.map((g) => ({
          id: g.id,
          label: `${g.nombre} ${g.apellido} - ${g.empresa || ''}`.trim(),
          nombre: `${g.nombre} ${g.apellido}`.trim(),
          email: g.email || '',
        }));
      } catch (e) {
        console.warn('No se pudieron cargar invitados', e);
      }
    },
    async loadGuests() {
      this.loading = true;
      await this.fetchGuests(this.meetingId);
      await this.loadOptions();
      this.loading = false;
    },
    resetPage() {
      this.currentPage = 1;
    },
    openScanner() {
      this.$buefy.toast.open({
        message: 'La URL del escáner se configurará mas adelante.',
        type: 'is-info',
      });
    },
    openGuestModal(type, guest = null) {
      this.presetType = type;
      this.editingGuest = guest;
      this.guestModalTitle = guest ? 'Editar invitado' : `Agregar ${type}`;
      this.guestFormKey += 1;
      this.showGuestModal = true;
    },
    closeGuestModal() {
      this.showGuestModal = false;
      this.editingGuest = null;
    },
    async saveGuest(payload) {
      const guestsArray = Array.isArray(payload) ? payload : [payload];
      for (const guest of guestsArray) {
        await this.saveGuestAction({ meetingId: this.meetingId, guest });
      }
      this.$buefy.toast.open({ message: 'Invitado(s) guardado(s) en la lista', type: 'is-success' });
      this.closeGuestModal();
      await this.loadGuests();
    },
    async removeGuest(guest) {
      const result = await Swal.fire({
        title: '¿Eliminar invitado?',
        text: `${guest.nombre} será removido.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, borrar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        await this.removeGuestsAction({ meetingId: this.meetingId, ids: [guest.id] });
        this.$buefy.toast.open({ message: 'Invitado eliminado', type: 'is-success' });
        await this.loadGuests();
      }
    },
    async removeSelected() {
      if (!this.hasSelection) return;

      const ids = this.checkedRows.map((row) => row.id);
      await this.removeGuestsAction({ meetingId: this.meetingId, ids });
      this.checkedRows = [];
      this.$buefy.toast.open({ message: 'Invitados eliminados', type: 'is-success' });
      await this.loadGuests();
    },
    async updateAttendance(status) {
      if (!this.hasSelection) return;
      const ids = this.checkedRows.map((row) => row.id);
      await this.updateGuestsStatus({ meetingId: this.meetingId, ids, updates: { estatusAsistencia: status } });
      this.$buefy.toast.open({ message: `Estatus de asistencia actualizado a "${status}"`, type: 'is-success' });
      await this.loadGuests();
    },
    async sendInvites() {
      if (!this.hasSelection) return;
      const ids = this.checkedRows.map((row) => row.id);
      await this.updateGuestsStatus({ meetingId: this.meetingId, ids, updates: { estatusCorreo: 'Enviado' } });
      this.$buefy.toast.open({ message: 'Invitaciones marcadas como enviadas', type: 'is-success' });
      await this.loadGuests();
    },
    exportGuests() {
      const headers = [
        'Nombre',
        'Correo',
        'NumeroSocio',
        'NombreSocio',
        'Vigencia',
        'Representante',
        'CorreoRepresentante',
        'EstatusCorreo',
        'EstatusAsistencia',
        'Codigo',
        'Tipo',
      ];

      const rows = this.filteredGuests.map((guest) => [
        guest.nombre,
        guest.correo,
        guest.numeroSocio,
        guest.nombreSocio,
        guest.vigencia,
        guest.representante,
        guest.correoRepresentante,
        guest.estatusCorreo,
        guest.estatusAsistencia,
        guest.codigo,
        guest.tipo,
      ]);

      const csvContent = [headers, ...rows].map((row) => row.join(',')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `invitados-reunion-${this.meetingId}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.$buefy.toast.open({ message: 'Lista exportada', type: 'is-info' });
    },
    closeImport() {
      this.showImportModal = false;
      this.importFile = null;
    },
    async handleImport() {
      this.$buefy.toast.open({ message: 'Importación simulada. Al conectar la API se procesará el archivo.', type: 'is-info' });
      this.closeImport();
    },
    attendanceColor(status) {
      if (status === 'Asistió' || status === 'Confirmado') return 'is-success is-light';
      if (status === 'No asistió') return 'is-danger is-light';
      return 'is-warning is-light';
    },
  },
};
</script>

<style scoped>
.buttons .button {
  margin-left: 6px;
  margin-bottom: 6px;
}

.guests-actions {
  justify-content: flex-end;
}
</style>
